import React from 'react';
import Store from '../store/Store';

type StoreItem = {
  name: string,
  defaultValue: any
};

const StoreListener = (items: string[] | StoreItem[], store: Store = Store.GLOBAL_STORE) => (Component) => {
  const name = Component.displayName || Component.name || 'Component';
  const debug = require('../debug/debug')(`wc:store:StoreListener(${name})`);
  return class StoreListener extends React.Component {
    static WrappedComponent = Component;

    constructor(props) {
      super(props);

      this._isMounted = true;
      this._items = Array.isArray(items) ? items : [items];

      const state = {};
      this._items.forEach((item: string | StoreItem) => {
        try {
          const name = typeof item === 'string' ? item : item.name;
          const defaultValue = typeof item === 'string' ? undefined : item.defaultValue;
          //store.addListener(name, this.onChange);
          state[name] = store.get(name, defaultValue);
        } catch (err) {
          debug('[SotreListener()] %s', err);
        }
      });

      this.state = state;
    }

    componentWillMount() {
      const state = {};
      this._items.forEach((item: string | StoreItem) => {
        const name = typeof item === 'string' ? item : item.name;
        const defaultValue = typeof item === 'string' ? undefined : item.defaultValue;
        if (!store.isSubscribed(name, this.onChange)) {
          store.addListener(name, this.onChange);
        }
        state[name] = store.get(name, defaultValue);
      });
      this.setState(state);
    }

    componentWillUnmount() {
      this._isMounted = false;
      this._items.forEach((item: string | StoreItem) => {
        const name = typeof item === 'string' ? item : item.name;
        store.removeListener(name, this.onChange);
      });
    }

    onRef = (ref) => {
      this._component = ref;
    };

    onChange = ({ name, data }) => {
      if (!this._isMounted) {
        return;
      }

      debug('[onChange()]', name, data);
      this.setState({ [name]: data });
    };

    render() {
      return <Component ref={this.onRef} {...this.props} {...this.state} />;
    }
  };
};

export default StoreListener;
